var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"links"},[_c('f-simple-navigation',{attrs:{"items":_vm.links,"render-nav":false,"icon-size":"16","vertical":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }